<div class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-setup'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full relative">
      <app-feature-flag-tabs class="w-full">
        <ng-container navTabs>
          <sbnb-page-header class="absolute top-0 left-0"></sbnb-page-header>
          <div
            class="flex mb-8 items-center justify-center sbnbDesktop:justify-between flex-col sbnbDesktop:flex-row gap-2">
            <h2 class="flex-1 mb-0">Properties</h2>

            <ng-container *ngIf="canAddProperty$ | async as canAdd">
              <sbnb-button
                [disabled]="!canAdd.canAdd"
                [matTooltip]="!canAdd.canAdd ? canAdd.message : null"
                label="+ Add Property"
                size="mini"
                routerLink="./new"></sbnb-button>
            </ng-container>
          </div>
        </ng-container>
        <div class="flex mb-8 justify-between">
          <h2 class="flex-1 mb-0">Setup</h2>

          <ng-container *ngIf="canAddProperty$ | async as canAdd">
            <sbnb-button
              [disabled]="!canAdd.canAdd"
              [matTooltip]="!canAdd.canAdd ? canAdd.message : null"
              label="+ Add Property"
              size="mini"
              routerLink="./new"></sbnb-button>
          </ng-container>
        </div>
      </app-feature-flag-tabs>

      <ng-container *ngIf="canAddProperty$ | async as canAdd">
        <sbnb-alert-card *ngIf="!canAdd.canAdd" context="info">{{ canAdd.message }}</sbnb-alert-card>
      </ng-container>

      <div *ngIf="propertiesData$ | async as data" class="overflow-x-auto w-full">
        <table mat-table class="w-full min-w-[720px]" [dataSource]="data">
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Property & Owner</th>
            <td mat-cell *matCellDef="let element">
              <div class="flex gap-2 items-center">
                <sbnb-mini-listing-img [imgSrc]="element.picture"></sbnb-mini-listing-img>
                <div class="flex flex-col gap-2">
                  <div><sbnb-truncate class="max-w-[300px]" [text]="element.name"></sbnb-truncate></div>
                  <div class="text__small night-lighter" *ngIf="element.owners?.length; else noOwner">
                    {{ element.owners?.[0]?.firstName }} {{ element.owners?.[0]?.name }}
                  </div>
                  <ng-template #noOwner>
                    <div class="flex gap-1 items-center text-lemon-darker text__small">
                      <span>Owner missing</span>
                    </div>
                  </ng-template>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Commission Rate -->
          <ng-container matColumnDef="commissionRate">
            <th mat-header-cell *matHeaderCellDef>Active Commission</th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="element.commissionRates?.length; else noCommissionRate" class="flex flex-col gap-2">
                <div>{{ element.commissionRates[0].name }}</div>
                <div class="text__small night-lighter">
                  Effective: {{ element.commissionRates[0].starts_at | date: 'mediumDate' }}
                </div>
              </div>
              <ng-template #noCommissionRate>
                <div class="flex gap-1 items-center text-lemon-darker text__small">
                  <sbnb-icon [size]="16" icon="alert-triangle"></sbnb-icon>
                  <span>Commission agreement missing</span>
                </div>
              </ng-template>
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
              <div class="flex gap-2 items-center justify-end">
                <sbnb-icon
                  [matTooltip]="!element?.owners?.length ? 'Owner missing' : 'Commission agreement missing'"
                  icon="alert-triangle"
                  [size]="16"
                  class="text-lemon-darker"
                  *ngIf="!element?.owners?.length || !element?.commissionRates?.length"></sbnb-icon>
                <ng-container *ngIf="accountingConnectionProperties$ | async as accountingConnectionProperties">
                  <sbnb-icon
                    matTooltip="Property is connected to an accounting system"
                    *ngIf="accountingConnectionProperties.has(element.id)"
                    icon="accounting-coins-stack"
                    [size]="16"
                    class="text-grass-darker"></sbnb-icon>
                </ng-container>
              </div>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <div class="flex justify-end">
                <sbnb-button size="mini" type="secondary" label="Details"></sbnb-button>
              </div>
            </td>
          </ng-container>

          <!-- Row definition -->
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr
            class="hover:bg-smoke-lighter cursor-pointer"
            mat-row
            *matRowDef="let row; columns: columns"
            [routerLink]="['../properties', row.id]"></tr>
        </table>
      </div>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
